import { useTranslation } from 'react-i18next';

import { ProtectedObserveRoute } from 'app/providers/RouterProvider/components/ProtectedObserveRoute';
import { HomeRoutePath } from 'shared/constants/router';
import { useIsParentHelper } from 'shared/hooks/user';

import type { RouteObject } from 'app/providers/RouterProvider/types';

export const useParentHelperRouteConfig = (): RouteObject[] | [] => {
  const { t } = useTranslation();
  const isParentHelper = useIsParentHelper();

  return isParentHelper
    ? [
        {
          path: HomeRoutePath.ParentHelper,
          handle: { crumb: t('header.breadcrumbs.parentHelper') },
          lazy: () =>
            import('pages/ParentHelper').then(({ ParentHelper }) => ({
              Component: () => (
                <ProtectedObserveRoute>
                  <ParentHelper />
                </ProtectedObserveRoute>
              ),
            })),
        },
      ]
    : [];
};
